import { useEffect } from "react";

import { identifyMixpanelUser } from "@/config/mixpanel";
import { useUser } from "@/providers/auth/useUser";

export const useMixpanelIdentifier = () => {
  const { data: user } = useUser();

  useEffect(() => {
    if (user) {
      identifyMixpanelUser(user);
    }
  }, [user]);
};
